export enum Orientation {
  Axial = 'Axial',
  Coronal = 'Coronal',
  Sagittal = 'Sagittal',
  Sax = 'Sax',
  Lax2CV = 'Lax2CV',
  Lax3CV = 'Lax3CV',
  Lax4CV = 'Lax4CV',
  Lax5CV = 'Lax5CV',
  Oblique = 'Oblique',
  Undefined = 'Undefined',
}

export enum AnalysisType {
  OCG = 'OCG',
  FunctionSax = 'FunctionSax',
  FunctionLax = 'FunctionLax',
  Flow = 'Flow',
  Undefined = 'Undefined',
}
